export { default } from './programGridWithCategoryFilters';
